import { render } from "./ProchipDataForm.vue?vue&type=template&id=adc7453e&scoped=true"
import script from "./ProchipDataForm.vue?vue&type=script&lang=js"
export * from "./ProchipDataForm.vue?vue&type=script&lang=js"

import "./ProchipDataForm.vue?vue&type=style&index=0&id=adc7453e&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\55\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc7453e"]])

export default __exports__